"use client";

import type { WritableAtom } from "jotai";
import { useHydrateAtoms } from "jotai/utils";
type AnyWritableAtom = WritableAtom<unknown, never[], unknown>;

export const HydrateAtoms = ({
	values,
	children,
}: {
	children?: React.ReactNode;
	values: Array<[AnyWritableAtom, unknown]>;
}) => {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	useHydrateAtoms(values as any);
	return <>{children}</>;
};
